import { render, staticRenderFns } from "./AdminPaidOrders.vue?vue&type=template&id=c964a20e&scoped=true"
import script from "./AdminPaidOrders.vue?vue&type=script&lang=js"
export * from "./AdminPaidOrders.vue?vue&type=script&lang=js"
import style0 from "./AdminPaidOrders.vue?vue&type=style&index=0&id=c964a20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c964a20e",
  null
  
)

export default component.exports